import {
    Loading,
    Notification
} from 'element-ui'
import axios from 'axios'
import qs from 'qs'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       data: config.data,
//       _t: Date.parse(new Date().getTime()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date().getTime()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })

axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么

    if (response.data.status === false) {
        Notification.error({title: '错误', message: response.data.remark, duration: 3000})
    }
    return response
}, function (err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = '请求错误(400)'
                break
            case 401:
                err.message = '未授权，请重新登录(401)'
                break
            case 403:
                err.message = '拒绝访问(403)'
                break
            case 404:
                err.message = '请求出错(404)'
                break
            case 408:
                err.message = '请求超时(408)'
                break
            case 500:
                err.message = '服务器错误(500)'
                break
            case 501:
                err.message = '服务未实现(501)'
                break
            case 502:
                err.message = '网络错误(502)'
                break
            case 503:
                err.message = '服务不可用(503)'
                break
            case 504:
                err.message = '网络超时(504)'
                break
            case 505:
                err.message = 'HTTP版本不受支持(505)'
                break
            default:
                err.message = `连接出错(${err.response.status})!`
        }
    } else {
        err.message = '连接服务器失败!'
    }
    Notification.error({
        title: '错误',
        message: err.message,
        duration: 0
    })
    return Promise.reject(err)
})

// 获取数据
export function getMediaDrawPageList (params) {
    let loadingInstance = Loading.service({
        text: '加载中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/GetMediaDrawPageList?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 媒体商审核
export function exportMeidaDrawData (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/ExportMeidaDrawData?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 导出媒体商审核信息
export function outPutMediaInfo (params) {
    return axios.post(`/IAD_MediaCertificationReq/ExportData?_t=${new Date().getTime()}`, params).then(res => {
        return Promise.resolve(res.data)
    })
}

// 媒体商提现审核
export function ReviewMediaDraw (params, step) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/${step}?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 批量提现审核接口（后付）

export function BatchReviewMediaDraw (params, step) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/${step}?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 获取媒体提现申请
export function getMediaDrawInfo (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/GetMediaDrawInfo?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 提现申请发票列表(后付)
export function getSourceInvoiceList (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/GetSourceInvoiceList?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 提现申请发票列表(预付)
export function getPrepaidSourceInvoiceList (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/GetSourceInvoiceList?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 上传发票
export function uploadInvoiceImg (file) {
    let param = new FormData()
    param.append('file', file, file.name)
    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }

    let loadingInstance = Loading.service({
        text: '上传中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/UploadImg?_t=${new Date().getTime()}`, param, config).then(res => {
        loadingInstance.close()
        return Promise.resolve(res.data)
    })
}

// 添加发票明细接口
export function AddSourceInvoice (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/AddSourceInvoice?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

//更新发票明细接口

export function UpdateSourceInvoice (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_MediaDraw/UpdateSourceInvoice?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 获取媒体运营列表
export function getSourceOperatorUserList () {
    return axios.get(`/IAD_MediaDraw/GetSourceOperatorUserList?_t=${new Date().getTime()}`).then(res => {
        return Promise.resolve(res.data)
    })
}

// 获取媒介列表
export function getSourceUserList () {
    return axios.get(`/IAD_MediaDraw/GetSourceUserList?_t=${new Date().getTime()}`).then(res => {
        return Promise.resolve(res.data)
    })
}

// 获取预付媒体商信息列表
export function GetPrepaidMediaList (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/GetPrepaidMediaList?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 根据媒体商ID模糊查询媒体商列表
export function GetMediaUserList (params) {
    return axios.post(`/IAD_PrepaidMedia/GetMediaUserList?_t=${new Date().getTime()}`, params).then(res => {
        return Promise.resolve(res.data)
    })
}

// 修改预付明细备注
export function UpdateRemark (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/UpdateRemark?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 添加预付商
export function AddPrepaidMediaUser (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/AddPrepaidMediaUser?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 导入预付媒体商
export function ImportPrepaidMediaUser (param) {
    return axios.post(`/IAD_PrepaidMedia/ImportPrepaidMediaUser?_t=${new Date().getTime()}`, param).then(res => {
        return Promise.resolve(res.data)
    })
}

// 导入预付媒体商提现
export function ImportMediaDrawData (param) {
    return axios.post(`/IAD_MediaDraw/ImportMediaDrawData?_t=${new Date().getTime()}`, param).then(res => {
        return Promise.resolve(res.data)
    })
}

// 获取预付媒体商下预付明细列表
export function GetPrepaidMediaDetails (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/GetPrepaidMediaDetails?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 添加预付媒体商预付金额
export function AddPrepaidMediaAmount (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/AddPrepaidMediaAmount?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 添加发票明细接口（预付）
export function AddPreSourceInvoice (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/AddSourceInvoice?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 修改发票明细接口（预付）
export function UpdatePreSourceInvoice (params) {
    let loadingInstance = Loading.service({
        text: '处理中,请稍后...'
    })
    return axios.post(`/IAD_PrepaidMedia/UpdateSourceInvoice?_t=${new Date().getTime()}`, params)
            .then(res => {
                loadingInstance.close()
                return Promise.resolve(res.data)
            }).catch(err => {
                loadingInstance.close()
                return Promise.reject(err)
            })
}

// 获取广告主财务记录

export function GetFinancialRecordList (params) {
  let loadingInstance = Loading.service({
    text: '处理中,请稍后...'
  })
  return axios.post(`/IAD_AdrFinancialFlow/GetFinancialRecordList?_t=${new Date().getTime()}`, params)
    .then(res => {
      loadingInstance.close()
      return Promise.resolve(res.data)
    }).catch(err => {
      loadingInstance.close()
      return Promise.reject(err)
    })
}


// 获取销售列表
export function GetSalerUserList() {
  return axios.get(`/IadAdrRecharge/GetSalerUsers?_t=${new Date().getTime()}`).then(res => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/mediaWithdraw.js